// extracted by mini-css-extract-plugin
module.exports = {"root":"_237_pkPg0Lf3-8DhXL6Ps5"};